import { ActionTypes } from '../../constants/ActionTypes';
import { IreceiversOrg } from '../../interfaces';

const INIT_STATE = {
  letterDetail: {},
  draftDetail: {
    letterCode: '',
    signatureLetterReferTypeId: '',
    subject: '',
    secretariatToSecretariatFormatId: '',
    letterFolderId: '',
    confidentialTypeId: '',
    forwardToSender: '',
    letterDate: '',
    senderCode: '',
    letterTags: [],
    showDraftOnCentral: '',
    urgentTypeId: '',
    hasResponseRequired: '',
    receiversOrg: [],
    receiversCc: [],
    receiversBcc: [],
    letterBodyHTML: '',
    stylusPages: [],
    davTaskId: '',
    letterFolderName: '',
    unlimitedSignatures: false,
    signaturePath: [],
    hasSignaturePath: false,
    hasAccessToSignLetterTemplate: false,
    letterTemplateId: null,
  },
  letterTemplate: {},
  refersDetail: [],
  locationDetail: [],
  urgentType: {},
  classificationType: {},
  letterCode: '',
  onlyMe: false,
};

export default (state = INIT_STATE, action: any) => {
  switch (action.type) {
    case ActionTypes.ON_CLEAR_DRAFT: {
      const draftDetail = {
        letterCode: '',
        signatureLetterReferTypeId: '',
        subject: '',
        secretariatToSecretariatFormatId: '',
        letterFolderId: '',
        confidentialTypeId: '',
        forwardToSender: '',
        letterDate: '',
        senderCode: '',
        letterTags: [],
        showDraftOnCentral: '',
        urgentTypeId: '',
        hasResponseRequired: '',
        receiversOrg: [],
        receiversCc: [],
        receiversBcc: [],
        letterBodyHTML: '',
        stylusPages: [],
        davTaskId: '',
        letterFolderName: '',
        unlimitedSignatures: false,
        signaturePath: [],
        hasSignaturePath: false,
        hasAccessToSignLetterTemplate: false,
        letterTemplateId: null,
      };
      return {
        ...state,
        draftDetail,
        letterCode: action.payload,
      };
    }

    case ActionTypes.GET_LETTER_DETAIL: {
      state.letterDetail = {};

      return {
        ...state,
        letterCode: action.payload,
      };
    }

    case ActionTypes.GET_LETTER_TEMPLATE_SUCCESS: {
      return {
        ...state,
        letterTemplate: action.payload,
      };
    }

    case ActionTypes.FETCH_LETTER_DETAIL_SUCCESS: {
      return {
        ...state,
        letterDetail: action.payload,
      };
    }

    case ActionTypes.GET_DRAFT_DETAIL: {
      const draftDetail = {
        loading: true,
        letterCode: '',
        signatureLetterReferTypeId: '',
        subject: '',
        secretariatToSecretariatFormatId: '',
        letterFolderId: '',
        confidentialTypeId: '',
        forwardToSender: '',
        letterDate: '',
        senderCode: '',
        letterTags: [],
        showDraftOnCentral: '',
        urgentTypeId: '',
        hasResponseRequired: '',
        receiversOrg: [],
        receiversCc: [],
        receiversBcc: [],
        letterBodyHTML: '',
        stylusPages: [],
        davTaskId: '',
        letterFolderName: '',
        unlimitedSignatures: false,
        signaturePath: [],
        hasSignaturePath: false,
        hasAccessToSignLetterTemplate: false,
        letterTemplateId: null,
        letterId: 0,
      };

      return {
        ...state,
        draftDetail,
        letterCode: action.payload,
      };
    }

    case ActionTypes.FETCH_DRAFT_DETAIL_SUCCESS: {
      const draftDetail = action.payload;
      draftDetail.loading = false;
      return {
        ...state,
        draftDetail: draftDetail,
      };
    }

    case ActionTypes.GET_LETTER_REFERS: {
      return {
        ...state,
        letterCode: action.payload.letterCode,
        onlyMe: action.payload.onlyMe,
      };
    }

    case ActionTypes.FETCH_LETTER_REFERS_SUCCESS: {
      return {
        ...state,
        refersDetail: action.payload,
      };
    }

    //URGENTTYPE
    case ActionTypes.GET_URGENT_TYPE: {
      return {
        ...state,
      };
    }

    case ActionTypes.FETCH_URGENT_TYPE_SUCCESS: {
      return {
        ...state,
        urgentType: action.payload,
      };
    }

    //CLASSIFICATIONTYPE
    case ActionTypes.GET_CLASSIFICATION_TYPE: {
      return {
        ...state,
      };
    }

    case ActionTypes.FETCH_CLASSIFICATION_TYPE_SUCCESS: {
      return {
        ...state,
        classificationType: action.payload,
      };
    }

    case ActionTypes.CHANGE_STATE_ITEMS_VALUE: {
      const itemKey = action.payload.key;
      const value = action.payload.value;

      const { draftDetail } = state as any;
      draftDetail[itemKey] = value;

      return {
        ...state,
      };
    }

    case ActionTypes.CHANGE_STATE_ITEMS_VALUE_WITH_TYPE:
      {
        if (action.payload.type === '' || action.payload.key === '')
          return {
            ...state,
          };
        const { draftDetail } = state as any;
        const itemKey = action.payload.key;
        if (action.payload && action.payload.value) {
          const value: IreceiversOrg = {
            id:
              action.payload?.value?.id ||
              action.payload?.value?.code ||
              action.payload?.value?.personCode,
            text: action.payload?.value?.text || action.payload?.value?.name,
            sendSms: false,
            isConfidential: false,
            sendEmail: false,
            realName:
              action.payload?.value?.text || action.payload?.value?.name,
            type: 2,
          };
          const doType = action.payload.type;

          if (doType === 'ADD') {
            let compare: any;
            compare = draftDetail[itemKey].filter(
              (item: any) => item.personCode === value.id,
            );
            if (compare.length === 0) {
              compare = draftDetail[itemKey].filter(
                (item: any) => item.code === value.id,
              );
              if (compare.length === 0)
                compare = draftDetail[itemKey].filter(
                  (item: any) => item.id === value.id,
                );
            }

            if (compare.length <= 0) {
              draftDetail[itemKey].push(value);
            }
          } else if (doType === 'DEL') {
            draftDetail[itemKey] = draftDetail[itemKey].filter(
              (item: any) => item.personCode !== value.id,
            );
            draftDetail[itemKey] = draftDetail[itemKey].filter(
              (item: any) => item.code !== value.id,
            );
            draftDetail[itemKey] = draftDetail[itemKey].filter(
              (item: any) => item.id !== value.id,
            );
          }
          return {
            ...state,
          };
        }
      }
      break;
    case ActionTypes.SAVE_LETTER: {
      const { draftDetail } = state;
      const model = {
        letterCode: draftDetail.letterCode,
        letterTypeId: null,
        subject: draftDetail.subject,
        secretariatToSecretariatFormatId:
          draftDetail.secretariatToSecretariatFormatId,
        letterFolderId: draftDetail.letterFolderId,
        confidentialTypeId: draftDetail.confidentialTypeId,
        forwardToSender: draftDetail.forwardToSender,
        letterDate: draftDetail.letterDate,
        letterSenderCode: draftDetail.senderCode,
        letterTags: draftDetail.letterTags,
        showDraftOnCentral: draftDetail.showDraftOnCentral,
        urgentTypeId: draftDetail.urgentTypeId,
        hasResponseRequired: draftDetail.hasResponseRequired,
        receiversOrg: draftDetail.receiversOrg,
        receiversCc: draftDetail.receiversCc,
        receiversBcc: draftDetail.receiversBcc,
        letterBodyHTML: draftDetail.letterBodyHTML,
        stylusPages: draftDetail.stylusPages,
        davTaskId: draftDetail.davTaskId,
      };
      return {
        ...state,
        model,
      };
    }

    case ActionTypes.SAVE_LETTER_SUCCESS: {
      //showSuccess
      return {
        ...state,
      };
    }

    case ActionTypes.GET_LETTER_LOCATION: {
      return {
        ...state,
        letterCode: action.payload,
      };
    }

    case ActionTypes.FETCH_LETTER_LOCATION_SUCCESS: {
      return {
        ...state,
        locationDetail: action.payload,
      };
    }

    case ActionTypes.ON_CLEAR_DRAFT_RECEIVERS: {
      const { draftDetail } = state;
      draftDetail.receiversOrg = [];
      draftDetail.receiversCc = [];
      draftDetail.receiversBcc = [];

      return {
        ...state,
        draftDetail,
      };
    }

    default:
      return state;
  }
};
